import React from 'react';

export default function MobileCallBar() {
  return (
    <a
      href="tel:+18887788606"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 flex items-center justify-center gap-2 bg-amber-500 hover:bg-amber-400 active:bg-amber-500 text-navy-950 font-bold text-base py-3.5 shadow-[0_-2px_10px_rgba(0,0,0,0.15)]"
      style={{ paddingBottom: 'calc(0.875rem + env(safe-area-inset-bottom))' }}
    >
      <svg className="w-5 h-5 shrink-0 animate-pulse" fill="currentColor" viewBox="0 0 24 24">
        <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1L6.6 10.8z"/>
      </svg>
      Call Now: +1 (888) 778-8606
    </a>
  );
}
